(function ($) {


RVwys.plugin['UndoRedo'] = {};
 $(document).bind('ready',function(){
 
 
 });
 $(document).bind('editorReady',function() {
	 $('.UndoRedo').click(function() {
		 
		 RVwys.history[$(this).attr('cmd')]();
		 
		 return false;
		 if (!$(this).attr('id').match(/_ena/img)) {
			 var cmd = $(this).attr('cmd');
			 if(RVwys.currentEditor) {
				frameBody = $('#frameBody').get(0);
		            frameBody = (frameBody.contentWindow || frameBody.contentDocument);
		            if (frameBody.document)frameBody = frameBody.document;
		            frameBody.execCommand(cmd);
		           // $(RVwys.currentEditor).focus();
		            $(RVwys.currentiFrame).focus();
			 }
		 }
	 });

	 
});
})(jQuery);
